export const calculateTabType = (activeTab: number, subTabIndex: number) => {
  if (activeTab === 0) {
    return subTabIndex === 0 ? 'purchase' : 'sale';
  }
  return subTabIndex === 0 ? 'exchange_initiated' : 'exchange_received';
};
